import { makeStyles } from "@material-ui/core/styles";
import theme from "theme";
import backgroungImage from "../../assets/landingpage_shutterstock_1187511808-blur.jpg";

const useStyles = makeStyles({
  "@global": {
    html: {
      height: "100%",
    },
    body: {
      margin: "0",
      height: "100%",
      fontFamily: "Arial, sans-serif",
      background: "#05090C",
    },
  },
  root: {
    minWidth: 275,
    maxWidth: 500,
    alignItems: "center",
    margin: theme.spacing(3),
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  landingPageHero: {
    minHeight: 300,
    padding: "5em",
    paddingLeft: "10em",
    marginTop: "9vh",
    [theme.breakpoints.up("md")]: {
      marginTop: "5vh",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "4em",
    },
  },
  landingPageTitle: {
    fontWeight: "bold",
    font: "normal normal bold 140px/162px Arial",
    lineHeight: "140px",
    [theme.breakpoints.down("xs")]: {
      font: "normal normal bold 3em/1em Arial",
    },
  },
  landingPageContainer: {
    background: `transparent url(${backgroungImage}) 30% 60% no-repeat`,
    color: "#FFFFFF",
    backgroundSize: "150%",
  },
  landingPageContainerResponsive: {
    background: `transparent url(${backgroungImage}) 30% 60% no-repeat`,
    color: "#FFFFFF",
  },
  landingPageDescription: {
    marginTop: "16px",
    maxWidth: "772px",
    lineHeight: 1.6,
    fontSize: "2.1vh",
    font: "normal normal normal 20px/30px Arial",
    [theme.breakpoints.down("lg")]: {
      fontSize: "1.8vh",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "75%",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
  },
  exploreButton: {
    font: "normal normal normal 20px/23px Arial",
    letterSpacing: "1.2px",
    marginTop: "5vh",
    background: "#2352d0",
    color: "#FFF",
    padding: "16px 15px",
    [theme.breakpoints.up("md")]: {
      marginTop: "3vh",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "5px 10px",
      fontSize: "14px",
    },
  },
  signInButton: {
    font: "normal normal normal 20px/23px Arial",
    color: "#FFF",
    padding: "0px",
    '&:hover': {
      background: 'none',
    }
  },
  signInComponent: {
    width: "max-content",
    float: "right",
    paddingTop: "1vh",
  },
  signInBox: {
    background: "#222B3A61 0% 0% no-repeat padding-box",
    borderRadius: "5px",
    width: "141px",
    height: "60px",
    float: "right",
    // margin: "10px 16px 16px 12px"
  },
  signInText: {
    margin: "16px",
    font: "normal normal normal 20px/30px Arial",
    letterSpacing: "0px"
  },
  accountIcon: {
   margin: "12px 0px 16px 12px"
  },
  applogo: {
    opacity: 1,
    padding: "22px 35px 35px 22px",
    cursor: "pointer",
    float: "right",
    height: "30px",
    // minHeight: 35,
  },
  landingPageGradient: {
    minHeight: 150,
    background: `transparent linear-gradient(180deg, #05090C 0%, #05090C00 100%) 0% 0% no-repeat padding-box`,
    transform: "matrix(-1, 0, 0, -1, 0, 0)",
  },
  aboutContainer: {
    minHeight: 200,
    paddingLeft: "10em",
    transform: "matrix(-1, 0, 0, -1, 0, 0)",
    [theme.breakpoints.down("sm")]: {
      padding: "2em",
      paddingLeft: "4em",
    },
  },
  sectionContainer: {
    paddingRight: "10vh",
    [theme.breakpoints.down("lg")]: {
      paddingRight: "4vh",
    },
    [theme.breakpoints.down("md")]: {
      paddingRight: "2vh",
      marginTop: "24px",
    },
  },
  sectionTitle: {
    color: "#FFFFFF",
    font: "normal normal bold 26px/30px Arial",
    fontWeight: "bold",
    marginBottom: 16,
    [theme.breakpoints.down("lg")]: {
      font: "normal normal bold 26px/30px Arial",
    },
  },
  sectionDescription: {
    color: "#FFFFFF",
    font: "normal normal normal 20px/30px Arial",
    [theme.breakpoints.up("lg")]: {
      // maxWidth: '90%',
      maxWidth: "345px",
    },
  },
  learnMore: {
    color: "#FFFFFF",
    fontSize: "2vh",
    marginTop: "0.7em",
    letterSpacing: "5px",
    paddingLeft: 0,
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      marginTop: "0em",
    },
  },
  nextButton: {
    background: "#F1AB2B",
    color: "#000000",
    padding: "1vh",
    marginLeft: "24px",
    borderRadius: "50%",
  },
  // scenarioCard: {
  //   //top: '246px',
  //   width: 'inherit',
  //   height: '270px',
  //   //width: '400px',
  //   position: "relative",
  //   backgroundColor: '#6690EF',
  //   '&:hover': {
  //     backgroundColor: '#052E9B',
  //     opacity: '64%',
  //     cursor: 'pointer',
  //   },
  // },
  // scenarioCardMedia:{
  //   position:'absolute',
  //   top:0,
  //   right:0,
  //   height:"100%",
  //   width:"100%",
  //   '&:hover': {
  //     opacity: '64%',
  //   },
  // },

  featureCardTitle: {
    color: "#FFFFFF",
    fontSize: "19px",
    fontWeight: "bold",
    [theme.breakpoints.down("lg")]: {
      fontSize: "2.3vh",
    },
  },
  scenContainer: {
    background: "#E5E9EE",
    padding: "1.5em",
    paddingLeft: "9em",
    [theme.breakpoints.down("sm")]: {
      padding: "2em",
      paddingLeft: "4em",
    },
  },
  scenarioContainer: {
    background: "#E5E9EE",
    // paddingTop: '3vh',
    // paddingLeft:'9em'
    padding: "1.5em",
    paddingLeft: "9em",
    [theme.breakpoints.down("sm")]: {
      padding: "2em",
      paddingLeft: "4em",
    },
  },
  scenarioTitle: {
    // paddingLeft: '10vh',
    color: "#393A42",
    fontSize: "3.5vh",
    fontWeight: "bold",
  },
  featureFont: {
    // paddingLeft: '8vh',
    // padding: '2vh',
    paddingRight: "2vh",
    color: "#393A42",
    fontSize: "3vh",
    fontWeight: "bold",
    [theme.breakpoints.down("lg")]: {
      fontSize: "2.3vh",
    },
  },
  filterFont: {
    // paddingLeft: '8vh',
    // padding: '2vh',
    paddingTop: "3vh",
    color: "#393A42",
    fontSize: "3vh",
    // fontWeight: 'bold',
    [theme.breakpoints.down("lg")]: {
      fontSize: "2.3vh",
    },
  },
  scenarioCardMedia: {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    width: "100%",
    opacity: "0.8",
    "&:hover": {
      opacity: "40%",
    },
  },
  scenarioCardContent: {
    position: "absolute",
    width: "30vh",
    paddingLeft: "29px",
    paddingTop: "32px",
    top: 0,
  },
  scenarioCardActionArea: {
    position: "relative",
    height: "100%",
  },
  scenarioCard: {
    position: "relative",
    // height:"30vh",
    // width:"40vh",
    height: "40vh",
    width: "100%",
    backgroundColor: "#6690EF",
    "&:hover": {
      backgroundColor: "#052E9B",
      cursor: "pointer",
    },
  },
  downloadButton: {
      font: "18px Arial",
      color: 'white',
      textDecoration: 'underline',
      textDecorationStyle: 'dotted',
      cursor: "pointer",
      marginLeft: "-8px",
      '&:disabled': {
        color: "white",
      },
  }
}, { index: 999 });

export default useStyles;
